
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.346 13.87v1.947c0 .96.693 1.74 1.57 1.74h13.246c.853 0 1.569-.78 1.569-1.74V13.87h-1.154v1.947c0 .26-.185.442-.415.442H1.915c-.23 0-.415-.208-.415-.442V13.87H.346zM7.846.552V11.04L5.469 8.626l-.761.96 3.346 3.375a.585.585 0 00.392.156.585.585 0 00.392-.156l3.346-3.375-.761-.96L9 11.066V.552H7.846z","fill":"#517BA6"}})])
          )
        }
      }
    